/**
 * Class containing any logic related to the handling of draft-js content objects
 */
export default class DraftJsService {


  /**
   * Determine whether the given raw content state contains any 'viewable' content.
   *
   * @param string contentState RAW contentState
   * @return bool
   */
  contentIsNotEmpty(contentState): boolean {

    for (let prop in contentState) {

      // Check blocks
      if (prop === 'blocks') {
        for (let key in contentState.blocks) {
          if (contentState.blocks[key].text.trim() !== '') {
            // If any of the block text appears empty after trimming whitespace, bail out
            return true
          }
        }
      }

      // Check entityMap for media
      if (prop === 'entityMap') {
        if (
          contentState.entityMap // null and undefined check
          && Object.keys(contentState.entityMap).length !== 0 // check for actual content
        ) {
          return true;
        }
      }

    }

    // Otherwise, we're looking empty
    return false;
  }


}
